import { FC, useEffect } from 'react';
import { Grid } from '@mui/material';
import { pages } from '../../../utils/common';
import MainTitle from '../../components/mainTitle';
import NavigationDrawer from '../../components/navigationDrawer/navigationDrawer';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'src/hooks/useTranslationHook';
import { useGuardianState } from './contexts/guardian.context';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import ChildSelector from './components/ChildSelector.component';
import ChildSwitcher from './components/ChildSwitcher.component';

const SelectChildContent: FC = () => {
  return (
    <ChildSelector />
  );
};

const GuardianContent: FC = () => {
  const { translateText } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedChildId, children } = useGuardianState();

  useEffect(() => {
    if (children.length > 1 && !selectedChildId) {
      return;
    }

    // Navigate to dashboard if on base guardian path
    if (location.pathname === pages.guardian.path) {
      navigate(`${pages.guardian.path}${pages.guardian.subPages?.dashboard?.path}`, {
        replace: true,
      });
    }
  }, [location.pathname, navigate, selectedChildId, children.length]);

  if (!selectedChildId) {
    return <SelectChildContent />;
  }

  return (
    <Grid
      container
      data-testid="guardian-content-container"
      sx={{ height: '100%', p: 4, overflowY: 'auto' }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'center' },
          justifyContent: 'space-between',
          pr: { xs: 0, sm: 4 },
          gap: { xs: 1, sm: 0 },
          mb: { xs: 1, sm: 0 },
          height: 'var(--main-title-height)',
        }}
        data-testid="guardian-view-header-container"
      >
        <MainTitle
          title={translateText('guardian.title')}
          subTitle={''}
          endAdornment={<ChildSwitcher />}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ height: 'calc(100% - var(--main-title-height))' }}
      >
        <Outlet />
      </Grid>
    </Grid>
  );
};

const GuardianView: FC = () => {
  const { selectedChildId, children } = useGuardianState();

  if (children.length > 1 && !selectedChildId) {
    return <SelectChildContent />;
  }

  return (
    <NavigationDrawer
      selectedPage={pages.guardian.path}
      window={window ?? null}
      isGuardian={true}
    >
      <Helmet>
        <title>{'Guardian'}</title>
      </Helmet>
      <GuardianContent />
    </NavigationDrawer>
  );
};

export default GuardianView;
